import React, { createContext, PropsWithChildren, useContext, useMemo, useState, ReactElement } from 'react';
import { Chart } from '../../../models/RiskProducts';
import { CompanyRiskProductsContextType } from './CompanyRiskProductsContext.types';

const CompanyRiskProductsContext = createContext<CompanyRiskProductsContextType | null>(null);

interface CompanyRiskProductsContextProviderProps extends PropsWithChildren {
  defaultActiveTab?: Chart | null; // For testing purposes, to check children when the active tab is already set
}

const CompanyRiskProductsContextProvider = ({
  children,
  defaultActiveTab = null,
}: CompanyRiskProductsContextProviderProps): ReactElement => {
  const [activeTab, setActiveTab] = useState<Chart | null>(defaultActiveTab);

  const value: CompanyRiskProductsContextType = useMemo(
    () => ({
      activeTab,
      setActiveTab,
    }),
    [activeTab, setActiveTab]
  );

  return <CompanyRiskProductsContext.Provider value={value}>{children}</CompanyRiskProductsContext.Provider>;
};

const useCompanyRiskProductsContext = (): CompanyRiskProductsContextType => {
  const context = useContext(CompanyRiskProductsContext);
  if (!context) {
    throw new Error('Hook must be used within the provider.');
  }

  return context;
};

export { CompanyRiskProductsContextProvider, useCompanyRiskProductsContext };
